import type { KdsTaskDetail } from '@ordr-as/ordr-service-types/epos';

/** Lookup maps derived from the location's KDS flows. */
export type FlowGraph = {
  stationIdByFlowStationId: Map<number, number>;
  upstreamsByFlowStationId: Map<number, number[]>;
  flowStationIdsByStationId: Map<number, number[]>;
  /** Position of a flow station along its flow (0 = first); orders progress chips. */
  depthByFlowStationId: Map<number, number>;
};

export const EMPTY_FLOW_GRAPH: FlowGraph = {
  stationIdByFlowStationId: new Map(),
  upstreamsByFlowStationId: new Map(),
  flowStationIdsByStationId: new Map(),
  depthByFlowStationId: new Map(),
};

export type ChipState = 'done' | 'ongoing' | 'todo';

/** One order line on an Expo card, with its progress across stations. */
export type ExpoDisplayItem = {
  key: string;
  name: string;
  quantity: number;
  modifiers: string[];
  comment: string | undefined;
  chips: { taskId: number | undefined; stationId: number | undefined; state: ChipState }[];
};

/** One order on the Expo board: all of its tasks across stations, grouped by groupId. */
export type ExpoOrder = {
  groupId: string;
  bookingOrderId: number | undefined;
  createdUtc: string | undefined;
  updatedUtc: string | undefined;
  eatIn: boolean;
  orderComment: string | undefined;
  tasks: KdsTaskDetail[];
  doneCount: number;
  totalCount: number;
  allDone: boolean;
};

export type ItemTotal = {
  name: string;
  quantity: number;
};
